import { HttpClient } from '@angular/common/http';
import { Injectable, EventEmitter } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../shared/ApiService/api.service';
import { Observable, of, BehaviorSubject, Subject } from 'rxjs';
import { delay, map } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class CandidateService {
  rekycAdharNo : any ;
  isModalShown : boolean = false;
  navchange: EventEmitter<any> = new EventEmitter();
  profileActive: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  loggedInUserCheck: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  grievanceData = new Subject<any>();
  candidateDetails: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  contractData :any;


  constructor(
    private apiService: ApiService
    
  ) {}

  emitProfileUpdateEvent() {
    this.navchange.emit();
  }

  getProfileUpdateEmitter() {
    return this.navchange;
  }

  createAssessment(data: any): Observable<any> {
    const createAssessmentUrl = `${environment.base_url}/assessment`;
    return this.apiService.post(createAssessmentUrl, data);
  }

  viewAssessment(id): Observable<any> {
    const getAssessmentUrl = `${environment.base_url + '/single-assessment/' + id}`
    return this.apiService.get(getAssessmentUrl);
  }
  viewMarksheetPreview(id): Observable<any> {
    const getAssessmentUrl = `${environment.base_url + '/dt_assessment/' + id + '/show-iti-candidates-marks-for-preview-screen'}`
    return this.apiService.get(getAssessmentUrl);
  }

  sendMarkDownloadRequest(id: any,data:any): Observable<any> {
    let createAssessmentUrl = '';
    createAssessmentUrl = `${environment.base_url}/dt_assessment/`+id+'/save-marksheet-type-choice-and-regenerate-marksheet';
    return this.apiService.post(createAssessmentUrl,data);
  }
  
  getAssessmentList(page: any, page_size: any, code?: any, publish_result?: any) {
    let getUrl = '';
    getUrl = `${environment.base_url}/assessment?page=${parseInt(page, 0)}&page_size=${parseInt(page_size, 0)}&mark_capture=true`;
    if (code) {
      getUrl += `&search=${code}`;
    }
    if(publish_result) {
      getUrl += `&publish_result=${publish_result}`;
    }
    return this.apiService.get(getUrl);
  }
  getSingleorderDetail(objectId: any): Observable<any> {
    const getFilesS3Url = `${environment.base_url + '/orders/' + objectId}`;
    return this.apiService.get(getFilesS3Url);
  }
  getAdharNo(userId){
    const url = `${environment.base_url + '/candidates/aadhaar-number-decrypt/' + userId}`;
    return this.apiService.get(url);
  }
  candiadteUpdateContact(data: any, id) {
    const candidateUpdateUrl = `${environment.base_url}/candidates/${id}/contacts`;
    return this.apiService.post(candidateUpdateUrl, data);
  }
  candiadteProfileCheckContact(data: any) {
    const candidateUpdateUrl = `${environment.base_url}/candidates/profile_check/store_user_details`;
    return this.apiService.post(candidateUpdateUrl, data);
  }
  reinitiatebeneid(id){
    const url = `${environment.base_url}/candidates/reinitiate-beneficiary-request/${id}`;
    return this.apiService.post(url);
  }
  setProfile(res) {
    this.profileActive.next(res);
  }

  getProfile() {
    return this.profileActive.asObservable();
  }

  setLoggedinUserCheck(value) {
    this.loggedInUserCheck.next(value);
  }

  getLoggedinUserCheck() {
    return this.loggedInUserCheck;
  }

  candidateSearch(page: any, page_size, code?: any, name?: any, gender?: any, state?: any, district?: any) {
    let getUrl = '';
    getUrl = `${environment.base_url}/candidates?page=${parseInt(page, 0)}&page_size=$`;
    return this.apiService.get(getUrl);
  }

  // candidateQualificationUpdate(data: any, id) {
  //   const candidateQualificationUpdateUrl = `${environment.base_url}/candidates/${id}/qualifications`;
  //   return this.http.post(candidateQualificationUpdateUrl, data);
  // }

  candidateDetailsGet(id: any) {
    const candidateDetailsGetUrl = `${environment.base_url}/candidates/${id}`;
    return this.apiService.get(candidateDetailsGetUrl);
  }

  candidateQRcodeDetailsGet(id: any) {
    const candidateDetailsGetUrl = `${environment.base_url}/users/getqrdata/${id}`;
    return this.apiService.get(candidateDetailsGetUrl);
  }
  getQrOpporDetails(id: any) {
    const candidateDetailsGetUrl = `${environment.base_url}/opportunities/search?page=1&page_size=15&establishment_id=${id}`;
    return this.apiService.get(candidateDetailsGetUrl);
  }

  listOpportunities(establishment_id: any, page: any, page_size, data?: any): Observable<any> {
    let listCoursesUrl = '';
    let query = '';
    // tslint:disable-next-line:max-line-length
    if (data) {
      query += data.search ? `&search=${data.search}` : '';
      query += (data.status !== '') ? '&status=' + data.status : '';
      // tslint:disable-next-line:max-line-length
      if(establishment_id){
        listCoursesUrl = `${environment.base_url + '/opportunities/drop-down?page=' + parseInt(page, 0) + '&page_size=' + parseInt(page_size, 0) + query + '&establishment_id=' + establishment_id}`;
      }else{
        listCoursesUrl = `${environment.base_url + '/opportunities/drop-down?page=' + parseInt(page, 0) + '&page_size=' + parseInt(page_size, 0) + query}`;
      }
    } else {
      // tslint:disable-next-line:max-line-length
      if(establishment_id){
        listCoursesUrl = `${environment.base_url + '/opportunities/drop-down?page=' + parseInt(page, 0) + '&page_size=' + parseInt(page_size, 0) + '&establishment_id=' + establishment_id}`;
      }else{
       listCoursesUrl = `${environment.base_url + '/opportunities/drop-down?page=' + parseInt(page, 0) + '&page_size=' + parseInt(page_size, 0)}`;
      }
    }
    return this.apiService.get(listCoursesUrl);
  }
  
  inviteCandidate(est_id, user_id, opportunity_id) {
    opportunity_id.users = [user_id];
    opportunity_id.establishment_id = est_id;
    const inviteCandidateUrl = `${environment.base_url}/candidates/invite`;
    return this.apiService.post(inviteCandidateUrl, opportunity_id);
  }

  contractDetailsGet(id: any) {
    const candidateDetailsGetUrl = `${environment.base_url}/candidates/contract_details/${id}`;
    return this.apiService.get(candidateDetailsGetUrl);
  }
  getCandiNewProfileDetails(id: any) {
    const candidateDetailsGetUrl = `${environment.base_url}/candidates/profile_check/view_user_details_candidate/${id}`;
    return this.apiService.get(candidateDetailsGetUrl);
  }
  candidateFilesGet(id: any, type, file) {
    const candidateFileUrl = `${environment.base_url}/getfileUrl/${type}/${file}/${id}`;
    return this.apiService.get(candidateFileUrl);
  }

  candidateFilesGetqu(id: any, type, file) {
    const candidateFileUrl = `${environment.base_url}/getfileUrl/${id}/${type}/${file}`;
    return this.apiService.get(candidateFileUrl);
  }

  profileCheckCandidateFilesGet(id: any, type, file) {
    const candidateFileUrl = `${environment.base_url}/get_file_candidate/${file}/${id}`;
    console.log(candidateFileUrl);
    
    return this.apiService.get(candidateFileUrl);
  }

  getApplication(contract_id: any) {
    const applicationFileUrl = `${environment.base_url}/assessment/applicationform`;
    return this.apiService.get(applicationFileUrl, {contract_id});
  }

  getFilesS3(model: any, filename: any, objectId: any): Observable<any> {
    const getFilesS3Url = `${environment.base_url + '/getfileUrl/' + model + '/' + filename + '/' + objectId}`;
    return this.apiService.get(getFilesS3Url);
  }

  getTradePrefList(term: string = null) {
    const getUrl = `${environment.base_url}/preference/suggestion?key=${term}`;
    return this.apiService.get(getUrl);
  }
  getSearchStateList(term: string = null) {
    const getUrl = `${environment.base_url}/states?search=${term}`;
    return this.apiService.get(getUrl);
  }
  getEstablishmentList(term:any){
    const getUrl = `${environment.base_url}/establishment-dropdown?search=${term}`;
    return this.apiService.get(getUrl);
  }
  candidateDashBoardDetails(id: any) {
    const getStatusList = `${environment.base_url}/candidates/${id}/dashboard`;
    return this.apiService.get(getStatusList);
  }
  candidateVerified() {
    const getStatusList = `${environment.base_url}/candidates/check_profile_verified`;
    return this.apiService.get(getStatusList);
  }
  candidatePreferenceUpdate(id: any, data: any) {
    const candidatePrefUpdateUrl = `${environment.base_url}/candidates/${id}/preferences`;
    return this.apiService.post(candidatePrefUpdateUrl, data);
  }

  candidateUniqueUpdate(data: any) {
    const candidatePrefUpdateUrl = `${environment.base_url}/candidates/verify-aadhaar`;
    return this.apiService.post(candidatePrefUpdateUrl, data);
  }

  candidateUniqueVIDUpdate(data: any) {
    const candidatePrefUpdateUrl = `${environment.base_url}/candidates/verify-vid-aadhaar`;
    return this.apiService.post(candidatePrefUpdateUrl, data);
  }


  candidateAadharUpdation(data: any) {
    const candidatePrefUpdateUrl = `${environment.base_url}/candidates/verify-aadhaar-number`;
    return this.apiService.post(candidatePrefUpdateUrl, data);
  }

  candidateUniqueOTPUpdate(data: any) {
    const candidatePrefUpdateUrl = `${environment.base_url}/candidates/verify-vid-aadhaar-otp`;
    return this.apiService.post(candidatePrefUpdateUrl, data);
  }

  verifySubmittedAadharOTP(data: any) {
    const candidatePrefUpdateUrl = `${environment.base_url}/candidates/verify-aadhaar-otp`;
    return this.apiService.post(candidatePrefUpdateUrl, data);
  }

  candidateQualificationMaster() {
    const candidateQualMaster = `${environment.base_url}/qualifications`;
    return this.apiService.get(candidateQualMaster);

  }
  candidateQulificationAdd(id: any, data: any) {
    const candidateQualificationAdd = `${environment.base_url}/candidates/${id}/qualifications`;
    return this.apiService.post(candidateQualificationAdd, data);
  }
  candidateQualificationUpdate(id: any, data: any, specializationId: any) {
    const candidateQualificationAdd = `${environment.base_url}/candidates/${id}/qualifications/${specializationId}`;
    return this.apiService.post(candidateQualificationAdd, data);
  }
  candidateQualificationDelete(id: any, specializationId: any) {
    const candidateQualificationDelete = `${environment.base_url}/candidates/${id}/qualifications/${specializationId}`;
    return this.apiService.delete(candidateQualificationDelete);
  }

  candidateFilesDocGet(id: any, specializationId: any) {
    const getQualificationDoc = `${environment.base_url}/getfileUrl/candidate/qualification_document/${id}/${specializationId}`;
    return this.apiService.get(getQualificationDoc);
  }
  candiadteApplication(page: any, page_size: any, status?: any, search?: any) {
    let getApplication = `${environment.base_url}/applications?page=${parseInt(page, 0)}&page_size=${parseInt(page_size, 0)}`;
    if (status) {
      getApplication += `&status=${status}`;
    }
    if (search) {
      getApplication += `&search=${search}`;
    }
    return this.apiService.get(getApplication);
  }
  candiadteApplicationView(id: any) {
    const opportunity = `${environment.base_url}/applications/${id}`;
    return this.apiService.get(opportunity);
  }
  candidateContractList(page: any, page_size: any, status?: any, code?: any, attendance_status?: any, result_status?:any,type?:any) {
    let contractList = '';
    contractList = `${environment.base_url}/candidates/contracts?page=${parseInt(page, 0)}&page_size=${parseInt(page_size, 0)}&is_attendance_marks=true`;
    if (status) {
      contractList += `&status=${status}`;
    }
    if (code) {
      contractList += `&search=${code}`;
    }
    if(attendance_status) {
      contractList += `&attendance_status=${attendance_status}`;
    }
    if(result_status) {
      contractList += `&result_status=${result_status}`;
    }
    if(result_status) {
      contractList += `&result_status=${result_status}`;
    }
    if(type){
      contractList += `&type=optional`;
    }
    return this.apiService.get(contractList);
  }


  candidateAddharOTP(data: any) {
    const candidatePrefUpdateUrl = `${environment.base_url}/candidates/ekyc-get-otp`;
    return this.apiService.post(candidatePrefUpdateUrl, data);
  }
  candidateVIDOTP(data: any) {
    const candidatePrefUpdateUrl = `${environment.base_url}/candidates/verify-vid-aadhaar`;
    return this.apiService.post(candidatePrefUpdateUrl, data);
  }
  

  validateAddharOTP(data: any) {
    const candidatePrefUpdateUrl = `${environment.base_url}/candidates/ekyc-verify-otp`;
    return this.apiService.post(candidatePrefUpdateUrl, data);
  }
  validateVIDOTP(data: any) {
    const candidatePrefUpdateUrl = `${environment.base_url}/candidates/verify-vid-aadhaar-otp`;
    return this.apiService.post(candidatePrefUpdateUrl, data);
  }

  submitKYCDetails(data: any) {
    const candidatePrefUpdateUrl = `${environment.base_url}/candidates/ekyc-update-details`;
    return this.apiService.post(candidatePrefUpdateUrl, data);
  }
  candidateGrievanceList(page: any, page_size: any, status?: any, code?: any, attendance_status?: any, result_status?:any,type?:any) {
    let contractList = '';
    contractList = `${environment.base_url}/grievance?page=${parseInt(page, 0)}&page_size=${parseInt(page_size, 0)}`;
    if (status) {
      contractList += `&status=${status}`;
    }
    if (code) {
      contractList += `&exam_no=${code}`;
    }
    if(attendance_status) {
      contractList += `&status=${attendance_status}`;
    }
    if(result_status) {
      contractList += `&result_status=${result_status}`;
    }
    if(result_status) {
      contractList += `&result_status=${result_status}`;
    }
    return this.apiService.get(contractList);
  }

  listTransactionDetails(id: any): Observable<any> {
    const listTRUrl = `${environment.base_url + '/orders/'+id+'/list'}`;
    return this.apiService.get(listTRUrl);
  }
  viewTransactionDetail(id: any): Observable<any> {
    const listTRUrl = `${environment.base_url + '/orders/' + id}`;
    return this.apiService.get(listTRUrl);
  }

  reTryPayment(id: any): Observable<any> {
    let createAssessmentUrl = '';
    createAssessmentUrl = `${environment.base_url}/orders/`+id;
    return this.apiService.post(createAssessmentUrl);
  }
  
  candidateContractView(id: any): Observable<any> {
    const contractView = `${environment.base_url}/candidates/contracts/${id}?include[]=refCandidate&include[]=refEstablishment`;
    return this.apiService.get(contractView);
  }

  getTerminationDetaiils(id: any): Observable<any> {
    const contractView = `${environment.base_url}/candidates/contract-termination-details/${id}`;
    return this.apiService.get(contractView);
  }
  getReasons(): Observable<any> {
    const contractView = `${environment.base_url}/candidates/termination-reason`;
    return this.apiService.get(contractView);
  }
   
  mutualTerminationGetOtp(data): Observable<any>{
    const getOtpUrl = `${environment.base_url}/mutual-termination/get-otp`;
    return this.apiService.post(getOtpUrl,data);
  }

   mutualTerminationVerifyOtp(data): Observable<any>{
    const getOtpUrl = `${environment.base_url}/mutual-termination/verify-otp`;
    return this.apiService.post(getOtpUrl,data);
  }

  candidateStipendView(id: any): Observable<any> {
    const stipendView = `${environment.base_url}/candidates/contracts/${id}/dbt-payment-status-list`;
    return this.apiService.get(stipendView);
  }
  candidateContractSign(id: any, data?) {
    const contractSign = `${environment.base_url}/candidates/contracts/${id}/sign`;
    return this.apiService.put(contractSign, data);
  }
  candidateReviewHistory(id: any, data?) {
    const contractHistory = `${environment.base_url}/candidates/profile_check/view_review_history_details_candidate/${id}`;
    return this.apiService.get(contractHistory);
  }
  candidateGrievanceHistory(id: any) {
    const contractHistory = `${environment.base_url}/grievance/view-history/${id}`;
    return this.apiService.get(contractHistory);
  }
  candidateContractReject(id: any, data?) {
    const contractReject = `${environment.base_url}/candidates/contracts/${id}/reject`;
    return this.apiService.put(contractReject, data);
  }

  qualificationMaster(typeOf?:any): Observable<any> {
    let listCoursesUrl = `${environment.base_url + '/qualifications'}`;
    if (typeOf) {
      listCoursesUrl += `?type=${typeOf}`;
    }
    return this.apiService.get(listCoursesUrl);
  }

  getAllSectors(search?: any): Observable<any> {
    const searchKey = search ? search : '';
    const getAllSectorsUrl = `${environment.base_url + '/sectors?page_size=9999&search=' + searchKey}`;
    return this.apiService.get(getAllSectorsUrl);
  }


  listQualificationOnSearch(search_key : any, page_size = 9999): Observable<any> {
    const listQualificationUrl = `${environment.base_url + '/qp?' + 'search='+ search_key + '&page_size=' + page_size + '&status=enabled' + '&is_discontinued=false'}`;
    return this.apiService.get(listQualificationUrl);
  }

  candidateInvitations(page: any, page_size: any, status?: any, search?: any) {
    let invitation = `${environment.base_url}/invitations?page=${parseInt(page, 0)}&page_size=${parseInt(page_size, 0)}`;
    if (status) {
      invitation += `&status=${status}`;
    }
    if (search) {
      invitation += `&search=${search}`;
    }
    return this.apiService.get(invitation);
  }
  candidateLocations() {
    let location = `${environment.base_url}/apprenticeship-mela/get-preferred-locations`;
    return this.apiService.get(location);
  }
  locationUpdate(data?: any,id?:any,action?:any) {
    let locationDetails 
    if(action === 'Add'){
      locationDetails = `${environment.base_url}/apprenticeship-mela/add-preferred-location`;
      return this.apiService.post(locationDetails, data);
    }else{
      locationDetails = `${environment.base_url}/apprenticeship-mela/update-preferred-location/${id}`;
      return this.apiService.put(locationDetails, data);
    }

  }
  locationDelete(id?:any) {
    const locationDetails = `${environment.base_url}/apprenticeship-mela/delete-preferred-location/${id}`;
    return this.apiService.delete(locationDetails);
  }
  candiadteBankDetails(id: any, data?: any) {
    const bankDetails = `${environment.base_url}/candidates/${id}/update-bank-account`;
    return this.apiService.post(bankDetails, data);
  }
  candiadteGrivanceInfo() {
    const infoDetails = `${environment.base_url}/grievance/raise-gr`;
    return this.apiService.get(infoDetails);
  }
  candiadteGetBankName() {
    const viewDetails = `${environment.base_url}/getBankList`;
    return this.apiService.get(viewDetails);
  }
  getIFSCcodeDetails(code) {
    const infoDetails = `${environment.base_url}/getBranchList?ifsc_code=`+code;
    return this.apiService.get(infoDetails);
  }
  sendGrievanceData(data: any) {
    this.grievanceData.next(data);
  }
  getrievanceData(): Observable<any> {
    return this.grievanceData.asObservable();
  }

  candiadteGrivanceView(id: any) {
    const viewDetails = `${environment.base_url}/grievance/${id}`;
    return this.apiService.get(viewDetails);
  }
  candiadteGrivanceReq(data?: any) {
    const bankDetails = `${environment.base_url}/grievance/create`;
    return this.apiService.post(bankDetails, data);
  }
  candiadteNonITItoITI(data?: any) {
    const bankDetails = `${environment.base_url}/grievance/create`;
    return this.apiService.post(bankDetails, data);
  }
  candiadteDraftGrivanceReq(data?: any,id?:any) {
    const grDetails = `${environment.base_url}/grievance/${id}`;
    return this.apiService.put(grDetails, data);
  }
  GRsendbackForCorrection(data, id): Observable<any> {
    const getGRUrl = `${environment.base_url + '/grievance/grievance-update-status/' + id}`;
    return this.apiService.post(getGRUrl, data);
  }

  GRdeted(id): Observable<any> {
    const getGRUrl = `${environment.base_url + '/grievance/' + id + '/delete'}`;
    return this.apiService.delete(getGRUrl);
  }

  candidatePaymentDetails(id: any) {
    const paymentData = `${environment.base_url}/candidates/${id}/payment`;
    return this.apiService.get(paymentData);
  }
  contractCancel(id: any, data: any) {
    const contractUrl = `${environment.base_url}/candidates/contracts/${id}/terminate`;
    return this.apiService.post(contractUrl, data);
  }
  absorbContract(id: any, data: any) {
    const absorbContractUrl = `${environment.base_url}/candidates/contracts/${id}/contract-absorption`;
    return this.apiService.post(absorbContractUrl, data);
  }
  getContractWitnessFile(model: any, filename: any, objectId: any, witnessId: any): Observable<any> {
    const getFileUrl = `${environment.base_url}/getfileUrl/${model}/${filename}/${objectId}/${witnessId}`;
    return this.apiService.get(getFileUrl);
  }
  getDisablity(){
    const getFileUrltype = `${environment.base_url}/disability-list`;
    return this.apiService.get(getFileUrltype);

  }


  getAcDtCandidateContractList(page: any, page_size: any, status?, search?) {
    let url = `${environment.base_url}/candidates/contracts?type=designated&is_attendance_marks=true&page=${page}&page_size=${page_size}`
    if (status) {
      url += `&status=${status}`;
    }
    if (search) {
      url += `&search=${search}`;
    }
    return this.apiService.get(url);
  } 

  getAcDtCandidateContractListForCertification(page: any, page_size: any, status?, search?) {
    let url = `${environment.base_url}/dt_assessment?status=pass&page=${page}&page_size=${page_size}`
    if (search) {
      url += `&search=${search}`;
    }
    return this.apiService.get(url);
  } 

  getAITTExamLists(page: any, page_size: any, status?, search?) {
    let url = `${environment.base_url}/dt_assessment?page=${page}&page_size=${page_size}`
    if (search) {
      url += `&search=${search}`;
    }
    return this.apiService.get(url);
  } 

  getActiveSchedule() {
    const url = `${environment.base_url}/schedule?search=published`
    return this.apiService.get(url)
  }

  getGrivanceActiveSchedule() {
    const url = `${environment.base_url}/schedule?search=completed&gr_status=published`
    return this.apiService.get(url)
  }

  getAssessmentIDForApplyForAssessment() {
    const url = `${environment.base_url}/dt_assessment_master?status=ongoing`
    return this.apiService.get(url)
  }

  getPaymentDetails(examID) {
    const url = `${environment.base_url}/nimi/candidate/order-details/${examID}`
    return this.apiService.get(url)
  }

  applyForAssessment(contractId, data) {
    const url = `${environment.base_url}/candidates/contracts/${contractId}/apply-assessment`
    return this.apiService.post(url, data);
  }

  retryNimiPayment(data){
    const url = `${environment.base_url}/nimi/retry-payment`
    return this.apiService.post(url, data);
  }

  checkStatusForTransaction(id){
    const url = `${environment.base_url}/nimi/dt-checkStatus/${id}`
    return this.apiService.post(url);
  }
  getLocationService() {
    const url = `${environment.base_url}/candidates/display-location`
    return this.apiService.get(url)
  }

  getNimiStatus(orderId){
    const url = `${environment.base_url}/nimi/order-details/${orderId}`
    return this.apiService.get(url)
  }
  returnRoleACDTMapping(role) {
    switch (role) {
      case 'eligible_for_assessment' : return 'Eligible for Assessment';
      case 'not_eligible_for_assessment': return 'Not Eligible for Assessment';
      case 'applied_for_assessment': return 'Applied for Assessment';
      case 'center_mapped': return 'Exam Center Mapped';
      case 'hall_ticket_generated': return 'Hall Ticket Generated';
      case 'pass': return 'Pass';
      case 'fail': return 'Fail';
      case 'attendance_updated': return 'Attendance Updated'
      case 'attendance_not_updated': return 'Attendance not Updated';
      case 'marks_updated': return 'Marks Updated';
      case 'marks_not_updated': return 'Marks not Updated';
      case 'certificate_generated' : return 'Certificate Generated'
      case 'completed' : return 'Completed'
    }
  }

  

  getACDTContractDetail(contractId) {
    const url = `${environment.base_url}/dt_mark/contract/${contractId}?include[]=refCandidate&include[]=refEstablishment`
    return this.apiService.get(url)
  }
  
  downloadACDTHallTicket(candidateId,contractId) {
    let url = `${environment.base_url}/getfileUrl/hall_tickets/hallticket_path/${candidateId}/${contractId}`
    return this.apiService.get(url);
  }

  downloadMarksSheet(assessmentId) {
    const url = `${environment.base_url}/getfileUrl/marksheet/marksheet_path/${assessmentId}`
    return this.apiService.get(url);
  }

  downloadCertificate(assessmentId) {
    const url = `${environment.base_url}/getfileUrl/certificate/certificate_path/${assessmentId}`
    return this.apiService.get(url);
  }

  downloadActiveSchedule() {
    const url = `${environment.base_url}/schedule?status=published`
    return this.apiService.get(url);
  }

  viewAittMarksheetAssessment(id): Observable<any> {
    const getAssessmentUrl = `${environment.base_url + '/aitt-marksheet-assessment/' + id}`
    return this.apiService.get(getAssessmentUrl);
  }

  viewAittCertificateAssessment(id): Observable<any> {
    const getAssessmentUrl = `${environment.base_url + '/aitt-assessment-certificate/' + id}`
    return this.apiService.get(getAssessmentUrl);
  }

  viewLegacyCertificateAssessment(id): Observable<any> {
    const getAssessmentUrl = `${environment.base_url + '/get-trainee/' + id}`
    return this.apiService.get(getAssessmentUrl);
  }
  
  verifyProfileImage(imageFile: any): Observable<any> {
    const getProfileUrl = `${environment.base_url}/candidates/image-identify`
    return this.apiService.post(getProfileUrl, imageFile);
  }

  getContractStatus(type) {
    return {
      '--': '--',
      'training_ongoing': 'Training Ongoing',
      'attendance_not_updated': 'Attendance not Updated',
      'attendance_updated': 'Attendance Updated',
      'assessment_due': 'Assessment due',
      'marks_entered': 'Marks Entered',
      'submitted_ssc': 'Submitted to SSC',
      'generated_marksheet': 'Marksheet Generated',
      'generated_certificate': 'Certified',
      'saved_as_draft': 'Saved as Draft',
      'marksheet_updated': 'Marksheet Updated',
      'marksheet_not_updated': 'Marksheet not Updated',
      'hall_ticket_generated': 'Hall Ticket Generated',
      'Termination Objection Raised': 'Termination Objection Raised',
      'pending': 'Pending',
      'disabled': 'Disabled',
      'approved': 'Approved',
      'rejected': 'Rejected',
      'edited': 'Edited',
      'verified': 'Verified',
      'reissued': 'Re-Issued',
      'completed': 'Completed',
      'cand_signed': 'Candidate Signed',
      'cand_rejected': 'Candidate Rejected',
      'male': 'Male',
      'female': 'Female',
      'transgender': 'Transgender',
      'expired': 'Expired',
      'cancelled': 'Cancelled',
      'sent_for_correction': 'Sent For Correction',
      'extension_approved': 'Extension Approved',
      'extension_rejected': 'Extension Rejected',
      'extension_sent_for_approval': 'Extension Sent For Approval',
      'extension_sent_for_correction': 'Extension Sent For Correction',
      'termination_approved': 'Termination Approved',
      'termination_rejected': 'Termination Rejected',
      'termination_sent_for_approval': 'Termination Sent For Approval',
      'termination_sent_for_correction': 'Termination Sent For Correction',
      'terminated_by_advisor': 'Terminated By Advisor',
      'rejected_by_advisor' : 'Rejected By Advisor',
      'pending_with_establishment' : 'Pending with Establishment',
      'pending_with_candidate' : 'Pending with Candidate',
      'pending_with_advisor' : 'Pending with Advisor',
      'digitally_terminated': 'Digitally Terminated',
      'novation_verified': 'Novation Approved',
      'novation_rejected': 'Novation Rejected',
      'novation_est_rejected': 'Establishment Rejected Novation',
      'sent_for_novation_approval': 'Novation Sent For Approval',
      'sent_for_novation_correction': 'Novation Sent For Correction',
      'novated': 'Novated',
      'issued': 'Contract Issued',
      'incorporation_certificate': 'Incorporation Certificate',
      'pf_registration_certificate': 'PF Registration Certificate',
      'registration_certificate': 'Registration Certificate',
      'telephone_bill': 'Telephone Bill',
      'electricity_bill': 'Electricity Bill',
      'rent_agreement': 'Rent Agreement',
      'gst_registration': 'GST Registration',
      'income_tax': 'Income Tax',
      'assessment_order': 'Assessment Order',
      'tan_allotment': 'TAN Allotment',
      'bank_statement': 'Bank Statement',
      'self_run': 'Self Run',
      'franchise': 'Franchise',
      'mutual': 'Mutual',
      'non_mutual': 'Non-Mutual'
    }[type];
  }

  candidateMobileOTP(data: any, id) {
    const updateMobileUrl = `${environment.base_url + '/users/' + id + '/update/mobile'}`;
    return this.apiService.post(updateMobileUrl, data);
  }
  mutualTerminateGetOTP(data: any): Observable<any>{
    const updateMobileUrl = `${environment.base_url + '/mutual-termination/get-otp'}`;
    return this.apiService.post(updateMobileUrl, data);
  }

  mutualTerminateResendOTP(data: any): Observable<any>{
    const updateMobileUrl = `${environment.base_url + '/mutual-termination/resend-otp'}`;
    return this.apiService.post(updateMobileUrl, data);
  }

   raiseObjection(data, contract_id): Observable<any>{
    const Url = `${environment.base_url + '/candidates/contracts/'+ contract_id + '/raise-objection'}`;
    return this.apiService.post(Url, data);
  }

  mutualTerminateVerifyOTP(data: any): Observable<any>{
    const updateMobileUrl = `${environment.base_url + '/mutual-termination/verify-otp'}`;
    return this.apiService.post(updateMobileUrl, data);
  }

  validateMobileOTP(data: any, id) {
    const validateMobileUrl = `${environment.base_url + '/users/' + id + '/otp/verify'}`;
    return this.apiService.post(validateMobileUrl, data);
  }

  resendeMobileOTP(data: any, id): Observable<any> {
    const resendMobileUrl = `${environment.base_url + '/users/' + id + '/otp/resend'}`;
    return this.apiService.post(resendMobileUrl, data);
  }

  getGreeting(): { message: string, icon: string } {
    const hour = new Date().getHours();
    
    if (hour < 12) {
      return { message: 'Good Morning', icon: 'sd sd-sun' };
    } else if (hour < 17) {
      return { message: 'Good Afternoon', icon: 'sd sd-sunrise' };
    } else {
      return { message: 'Good Evening', icon: 'sd sd-sun-setting-02' };
    }
  }

  getCandidateDetails(): Observable<any> {
    return this.candidateDetails.asObservable();
  }

  setCandidateDetails(value) {
    this.candidateDetails.next(value);
  }

  setContractData(contract){
    this.contractData = contract;
  }
  getContractData(){
    return this.contractData;
  }

  getTerminationEligibleContracts(page: any, page_size: any, status?: any, code?: any) {
    let contractList = '';
    contractList = `${environment.base_url}/candidates/contracts?raise_termination=true&page=${parseInt(page, 0)}&page_size=${parseInt(page_size, 0)}&is_attendance_marks=true`;
    if (status) {
      contractList += `&status=${status}`;
    }
    if (code) {
      contractList += `&search=${code}`;
    }
    return this.apiService.get(contractList);
  }

  getReceivedTerminationRequests(page: any, page_size: any, status?: any, code?: any) {
    let contractList = '';
    contractList = `${environment.base_url}/candidates/contracts/termination/request-received?page=${parseInt(page, 0)}&page_size=${parseInt(page_size, 0)}&is_attendance_marks=true`;
    if (status) {
      contractList += `&status=${status}`;
    }
    if (code) {
      contractList += `&search=${code}`;
    }
    return this.apiService.get(contractList);
  }

  getTerminationRequestStatus(page: any, page_size: any, status?: any, code?: any) {
    let contractList = '';
    contractList = `${environment.base_url}/candidates/contracts/termination/request-status?page=${parseInt(page, 0)}&page_size=${parseInt(page_size, 0)}&is_attendance_marks=true`;
    if (status) {
      contractList += `&status=${status}`;
    }
    if (code) {
      contractList += `&search=${code}`;
    }
    return this.apiService.get(contractList);
  }

  getPlacementDetails(){
    let contractList = '';
    contractList = `${environment.base_url}/candidates/contracts/get-absorption-request`;
     return this.apiService.get(contractList);
  }
  signConsent(id, data){
     const terminateContractUrl = `${environment.base_url}/candidates/contracts/${id}/submit-absorption-consent`;
    return this.apiService.post(terminateContractUrl, data);
  }

}
